import React, { FC } from 'react';
import Button from '~/components/Button';
import { ArrowRight } from '../../Icons/fill';
import ContinueToVASStyled from './ContinueToVASStyled';

interface Props {
  clickHandler: () => void;
  ndiBanner?: boolean;
}

const ContinueToVAS: FC<Props> = ({ clickHandler, ndiBanner }) => (
  <ContinueToVASStyled ndiBanner={ndiBanner}>
    <p className="add-on__disclaimer">
      <Button
        className="add-on__btn-continue"
        data-testid="add-on__btn-continue--ps-on-lp"
        type="button"
        onClick={clickHandler}
      >
        <span>
          CONTINUE <ArrowRight />
        </span>
      </Button>
    </p>
  </ContinueToVASStyled>
);

ContinueToVAS.displayName = 'ContinueToVAS';

export default ContinueToVAS;
